import { IFormField, IFormSection } from "../web-form.objects"
import { PickListItem } from "../../../entities/pick-list/pick-list.entities";
import _ from "lodash";

export class MultiAddInputOptions {
    noItemDisplay: string; // What is shown when nothing is added
    isPickList: boolean = false; // if the add content should be pulled from pick list
    options: PickListItem[] = undefined;
    sortOptions: boolean = true;
    constructor(noItemDisplay: string, isPickList: boolean = false, options: PickListItem[] = undefined, sortOptions: boolean = true) {
        this.noItemDisplay = noItemDisplay;
        this.isPickList = isPickList;
        this.options = options;
        this.sortOptions = sortOptions;
    }
}

export class MultiAddInputField implements IFormField {
    fieldId: string; 
    displayName: string; 
    isRequired: boolean;
    propertyName: string; 
    defaultVal: any; 
    forObjProperty: boolean = true;
    shouldTriggerUpdate: boolean = false;

    formSection: IFormSection;

    options: MultiAddInputOptions;

    storedValues: string[];
    addedItemGallery: JQuery<HTMLElement>;
    addItemInput: JQuery<HTMLElement>;
    addItemBtn: JQuery<HTMLElement>;
    errorTextBlock: JQuery<HTMLElement>;
    formBlock: JQuery<HTMLElement>;

    constructor(propertyName: string, defaultVal: any, fieldId: string, displayName: string, isRequired: boolean, options: MultiAddInputOptions) {
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.isRequired = isRequired;
        this.propertyName = propertyName;
        this.defaultVal = defaultVal;
        this.options = options;


        this.storedValues = [];
    }

    initialize(formSection: IFormSection) {
        this.formSection = formSection;
        this.formBlock = $(`#${this.fieldId}`);
        this.addedItemGallery = this.formBlock.find(".added-content");

        //let formBlock = $(`#${this.fieldId}`);
        //this.addedItemGallery = formBlock.find(".added-content");
        this.addItemInput = this.formBlock.find(".multi-add-input");
        this.addItemBtn = this.formBlock.find(".multi-add-btn");
        this.errorTextBlock = this.formBlock.find(".error-msg");

        if (this.options.isPickList) {
            this.generateDropdown();
        };

        this.initializeAddBtn();
        this.drawGallery();
    }

    private drawGallery() {
        this.addedItemGallery.empty();
        let content = "";
        if (this.storedValues.length == 0) {
            content = `<p class="added-content-placeholder">${this.options.noItemDisplay}</p>`;
            this.addedItemGallery.append(content);
        }
        else if (this.options.isPickList) {
            for (let i = 0; i < this.storedValues.length; i++) {
                let itemId = this.storedValues[i];
                let foundItem = this.options.options.find(item => item.Id.toString() == itemId);
                if (foundItem) {
                    content += `
                        <div class="card">
                            <div class="card-header" id="multi-add-heading-${i}">
                                <div class="row justify-content-between">
                                    <div class="col-auto">
                                        <div class="header-text">
                                            ${foundItem.Value}
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <a id="delete-item-btn-${i}" class="text-decoration-none header-delete-btn">
                                            <i class="fa-solid fa-trash-can"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `
                }
            }
            this.addedItemGallery.append(content);
            let multiAddField = this;
            this.addedItemGallery.find(".header-delete-btn").on("click", function () {
                let targetId: string = $(this).prop("id");
                let index: number = parseInt(targetId.replace("delete-item-btn-", ""));
                let foundItem = multiAddField.storedValues[index];
                if (foundItem) {
                    multiAddField.storedValues.splice(index, 1);
                    multiAddField.drawGallery();
                }
            })
        }
        else {
            for (let i = 0; i < this.storedValues.length; i++) {
                let itemVal = this.storedValues[i];
                if (itemVal) {
                    content += `
                        <div class="card">
                            <div class="card-header" id="multi-add-heading-${i}">
                                <div class="row justify-content-between">
                                    <div class="col-auto">
                                        <div class="header-text">
                                            ${itemVal}
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <a id="delete-item-btn-${i}" class="text-decoration-none header-delete-btn">
                                            <i class="fa-solid fa-trash-can"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `
                }
            }
            this.addedItemGallery.append(content);
            let multiAddField = this;
            this.addedItemGallery.find(".header-delete-btn").on("click", function () {
                let targetId: string = $(this).prop("id");
                let index: number = parseInt(targetId.replace("delete-item-btn-", ""));
                let foundItem = multiAddField.storedValues[index];
                if (foundItem) {
                    multiAddField.storedValues.splice(index, 1);
                    multiAddField.drawGallery();
                }
            })
        }

        this.refreshDropdown();
        this.triggerSectionUpdate(); // anytime options are updated
    }

    private generateDropdown() {
        this.addItemInput.find("option").remove();
        this.addItemInput.selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });

        // Add default option with no value to show no input (no favoritism)
        this.addItemInput.append(`<option hidden disabled selected value>-- Select --</option>`);

        if (this.options.sortOptions && this.options.options != undefined) {
            this.options.options.sort((x1, x2) => x1.Value.localeCompare(x2.Value));
        }

        if (this.options.options != undefined) {
            this.options.options.forEach(option => {
                this.addItemInput.append(new Option(option.Value, option.Id.toString(), false, false));
            })
        }

        this.addItemInput.selectpicker("refresh");
    }

    // Remove selected items from dropdown
    private refreshDropdown() {
        if (this.options.options != undefined) {
            let options = this.options.options.filter(option => !this.storedValues.some(item => item == option.Id.toString()));

            if (this.options.sortOptions) {
                options.sort((x1, x2) => x1.Value.localeCompare(x2.Value));
            }

            this.addItemInput.find("option").remove();
            // Add default option with no value to show no input (no favoritism)
            this.addItemInput.append(`<option hidden disabled selected value>-- Select --</option>`);

            options.forEach(option => {
                this.addItemInput.append(new Option(option.Value, option.Id.toString(), false, false));
            });

            this.addItemInput.selectpicker("refresh");
        }
    }

    private initializeAddBtn() {
        this.addItemBtn.off().on('click', () => {
            let input = this.getInput();
            if (this.validateInput()) {
                this.storedValues.push(input);
                this.drawGallery();
                this.addItemInput.val('');

                if (this.options.isPickList) {
                    this.refreshDropdown();
                }
                this.setErrorText();
            }
            else {
                this.setErrorText("Please add at least 1 item");
            }
        })
    }

    private validateInput(): boolean {
        let input = this.getInput();
        if (input) {
            return true;
        }
        return false;
    }

    private setErrorText(errorText: string = null) {
        if (errorText == null) {
            this.errorTextBlock.text('');
            this.errorTextBlock.addClass('d-none');
            this.resetValidDisplay();
        }
        else {
            this.errorTextBlock.text(errorText);
            this.errorTextBlock.removeClass('d-none');
            this.displayValid(false);
        }
    }

    private getInput(): string {
        let input = <string>this.addItemInput.val();
        return input;
    }

    getValue(): any {
        let val = this.defaultVal;

        let isValid = this.checkValid();
        let isChanged = this.checkChanged();
        if (isValid && isChanged) {
            val = this.storedValues.join("|");
        }

        return val;
    }

    setValue(formData: any) {
        this.storedValues = [];
        let formVal = _.get(formData, this.propertyName);
        if (formVal != undefined) {
            if (formVal) {
                this.storedValues = (<string>formVal).split("|");
            }
        }
        this.drawGallery();
    }

    checkValid(): boolean {
        if (this.isRequired) {
            if (this.storedValues.length == 0) {
                return false;
            }
            return true;
        }
        else {
            return true;
        }
    }

    checkChanged(): boolean {
        if (this.storedValues.length == 0) {
            return false;
        }
        return true;
    }

    displayValid(isValid: boolean) {
        // Keep existing dropdown behavior
        if (this.options.isPickList) {
            this.addItemInput.siblings(".dropdown-toggle").removeClass("is-valid is-invalid");
        } else {
            this.addItemInput.removeClass("is-valid is-invalid");
        }

        // Apply invalid styling to whole container
        if (!isValid) {
            this.formBlock.addClass("multi-add-invalid");
        } else {
            this.formBlock.removeClass("multi-add-invalid");
        }
    }

    resetValidDisplay() {
        if (this.options.isPickList) {
            this.addItemInput.siblings(".dropdown-toggle").removeClass("is-valid is-invalid");
        } else {
            this.addItemInput.removeClass("is-valid is-invalid");
        }
        this.formBlock.removeClass("multi-add-invalid");
    }


    triggerSectionUpdate() {
        if (this.formSection && this.shouldTriggerUpdate) {
            this.formSection.updateSection();
        }
    }
}

